import { ChangeDetectionStrategy, Component, computed, forwardRef, input, linkedSignal, untracked } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { ExpandableComponent } from '../../../common/expandable/expandable.component';
import { BranchItem } from '../../models';
import { LinkTreeComponent } from '../tree/tree.component';

@Component({
  selector: 'li[link-tree-branch]',
  templateUrl: './branch.component.html',
  styleUrl: './branch.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    forwardRef(() => LinkTreeComponent),
    FontAwesomeModule,
    ExpandableComponent
  ],
  host: {
    '[style.--depth]': 'depth()',
    '[class.expanded]': 'expanded()',
    '[class.type-group]': `type() === 'group'`,
    '[class.type-sub-section]': `type() === 'sub-section'`,
    '[class.type-section]': `type() === 'section'`,
  },
  hostDirectives: [
    RouterLink
  ]
})
export class LinkTreeBranchComponent {
  readonly item = input.required<BranchItem>();
  readonly depth = input(0);

  readonly type = computed(() => this.item().type);

  protected readonly childDepth = computed(() => {
    const toAdd = this.type() === 'group' ? 0 : 1;
    return this.depth() + toAdd;
  });

  protected readonly canToggle = computed(() => {
    switch (this.type()) {
      case 'nested': return true;
      case 'sub-section': return true;
      default: return false;
    }
  });

  readonly expanded = linkedSignal(() => {
    return !this.canToggle();
  });

  protected readonly icons = {
    faCaretRight
  } as const;

  toggle() {
    if (!untracked(this.canToggle))
      return;

    this.expanded.update(v => !v);
  }
}